<template>
  <div id="for-products-page">
    <CoinsBanner :banner="'prestamo-productos.png'" :isBusiness="false">
      <template v-slot:title>
        Financia la compra
        de productos sostenibles.</template>
    </CoinsBanner>
    <FundDestinations>
      <template v-slot:subtitle>Uso del crédito.</template>
      <template v-slot:title>¿Qué ecotecnologías se pueden <span class="bold">financiar</span>?</template>
    </FundDestinations>
    <LoanDetail 
      :isBusiness="false"/>
    <ExpressSimulator />
    <Benefits />
    <OwnSuccessStories :projects="successList">
      <template v-slot:title>
        Descubre qué proyectos <br> hemos <span class="bold">financiado</span>.
      </template>
    </OwnSuccessStories>
    <HowItWorks />
    <Requirements />
    <Teams :logo="'team-proveedor.png'">
      <template v-slot:title>¿Eres proveedor?</template>
      <template v-slot:text>Ofrece nuestro crédito a tus clientes <br> e incrementa tus ventas.</template>
    </Teams>
  </div>
</template>
    
<script>
import sal from 'sal.js'
import FundDestinations from '@components/landing-components/for-products-components/FundDestinations.vue';
import CoinsBanner from '@components/landing-components/for-business-components/CoinsBanner.vue';
import LoanDetail from '@components/landing-components/for-business-components/LoanDetail.vue';
import Benefits from '@components/landing-components/for-business-components/Benefits.vue';
import OwnSuccessStories from '@components/landing-components/for-business-components/OwnSuccessStories.vue';
import HowItWorks from '@components/landing-components/for-business-components/HowItWorks.vue';
import Requirements from '../../components/landing-components/for-business-components/Requirements.vue';
import Teams from '../../components/landing-components/for-business-components/Teams.vue';
import ExpressSimulator from '../../components/landing-components/loan-simulator/ExpressSimulator.vue';
export default {
  name: "HomePage",
  components: {
    CoinsBanner,
    FundDestinations,
    LoanDetail,
    Benefits,
    OwnSuccessStories,
    HowItWorks,
    Requirements,
    Teams,
    ExpressSimulator
  },
  mounted() {
    sal();
  },
  data() {
    return {
      successList: [
        {
          alias: "Universidad de Xalapa",
          photo: "univ-xalapa.jpeg",
          item_list: [
            { title: "Fuente de emisión:", value: "Energía" },
            { title: "Línea de acción:", value: "Solar fotovoltáico" },
            { title: "Beneficio:", value: "247 m2 instalados" },
            { title: "Monto:", value: "$1,490,024.00" },
            { title: "Estado:", value: "Veracruz" },
            { title: "Ahorros estimados:", value: "$284,896.71 MXN/año" },
            { title: "Huella de carbono:", value: "45.32 tonCO2/año" },
            { title: "Inversionistas:", value: "971" },
          ]
        },
        {
          alias: "Fit Crew",
          photo: "fit-crew.jpeg",
          item_list: [
            { title: "Fuente de emisión:", value: "Energía" },
            { title: "Línea de acción:", value: "Solar térmico" },
            { title: "Beneficio:", value: "247 m2 instalados" },
            { title: "Monto:", value: "$1,490,024.00" },
            { title: "Estado:", value: "CDMX" },
            { title: "Ahorros estimados:", value: "$600,240.00 MXN/año" },
            { title: "Huella de carbono:", value: "73.67 tonCO2/año" },
            { title: "Inversionistas:", value: "1298" },
          ]
        },
        {
          alias: "La Suprema",
          photo: "la-suprema.jpeg",
          item_list: [
            { title: "Fuente de emisión:", value: "Energía" },
            { title: "Línea de acción:", value: "Refrigeración eficiente" },
            { title: "Beneficio:", value: "7 equipos" },
            { title: "Monto:", value: "$3,446,260.00" },
            { title: "Estado:", value: "Sonora" },
            { title: "Ahorros estimados:", value: "--" },
            { title: "Huella de carbono:", value: "--" },
            { title: "Inversionistas:", value: "1980" },
          ]
        },
      ]
    }
  }
}
</script>
    
<style scoped></style>